/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

export const FontSizeContext = createContext();

export function FontSizeProvider({ children }) {
   const [fontSize, setFontSize] = useState('md');

   useEffect(() => {
      document.body.classList.remove('fontsize-xs', 'fontsize-sm', 'fontsize-md', 'fontsize-lg', 'fontsize-xl');
      document.body.classList.add(`fontsize-${fontSize}`);
   }, [fontSize]);

   const value = useMemo(() => ({ fontSize, setFontSize }), [fontSize]);

   return <FontSizeContext.Provider value={value}>{children}</FontSizeContext.Provider>;
}

FontSizeProvider.propTypes = {
   children: PropTypes.node.isRequired,
};
